<template>
  <div class="position-box">
    <div class="head">
      <div class="back-box" @click="goBack">
        <img class="icon" src="@/assets/icon_back.png" alt="back" />
      </div>
      <!-- <div>{{ $t("gjrz.title") }}</div> -->
    </div>
    <div class="cotainer">
      <div class="login-box">
        <div class="logo-box"><img class="logo" :src="webLogo" alt=""></div>
        <div class="title">{{webTitle}}</div>
      </div>
      <div class="tips">{{ $t("sztxmm.zh") }}</div>
      <div class="input-box">
        <input class="input" v-model="userName" type="text" :placeholder="$t('gjrz.qsrzh')" autocomplete="off"/>
      </div>
      <div class="tips">{{ $t("sztkmm.dlmm") }}</div>
      <div class="input-box">
        <input class="input" v-model="passwords" type="password" :placeholder="$t('sztkmm.dlmmts')" autocomplete="off"/>
      </div>
      <div class="btn-login btn-bg" @click="submit">{{ $t("gjrz.dl") }}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "login",
  data() {
    return {
      lang: "en",
      token: "",
      userName: '',
      passwords: '',
      index: 0,
      count: 1,
    };
  },
  mounted() {
    this.userName = localStorage.getItem('account') || '';
    this.passwords = localStorage.getItem('pwd') || '';
  },
  methods: {
    goBack() {
      this.$router.push("/index");
    },
    submit() {
      if (!this.userName) {
        this.$toast.center(this.$t("gjrz.qsrzh"));
        return false;
      }
      if(!this.passwords) {
        this.$toast.center(this.$t('sztkmm.dlmmts'));
        return false;
      }
      if(this.userName.indexOf('@') > 0){
          this.index = 1
      }else{
          this.index = 0
      }
      let params = {
          account: this.userName,
          password: this.passwords,
          index: this.index,
          sms_code: '',
          token: 1
      }
      if (this.count == 1) {
        this.count = 0;
      } else {
        return false;
      }
      this.$ajax.post('/web/userLogin',params).then((res) => {
        let resData = res.data;
        if(resData.code == 0 || resData.code == 4 || resData.code == 7){
            localStorage.setItem('token',resData.data.token);
            localStorage.setItem('account',this.userName);
            localStorage.setItem('pwd',this.passwords);
            localStorage.setItem('userID',resData.data.id);
            localStorage.setItem('isInnerUser',true);
            localStorage.setItem('userInfo',JSON.stringify(resData.data));
            this.count = 1;
            setTimeout(() => {
              this.$router.push('/index')
            }, 1000)
        }else{
          this.count = 1;
          this.$toast.center(resData.message);
          return;
        }
      }).catch(function(err){
          console.log(err)
      })
    },
  },
  filters: {

  },
};
</script>
<style scoped>
.position-box {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: auto;
  color: #cecece;
  font-size: 0.36rem;
  background: url("../assets/element-background.png") no-repeat center center;
  background-size: cover;
  overflow: hidden;
}
.center {
  text-align: center;
}
.head {
  position: relative;
  height: 1.2rem;
  font-size: 0.52rem;
  line-height: 1.2rem;
  /* background: #0e1530; */
  text-align: center;
}
.head .icon {
  position: absolute;
  left: 0.3rem;
  top: 0.3rem;
  width: 0.32rem;
  height: 0.6rem;
}
.cotainer {
  position: absolute;
  left: 0.4rem;
  right: 0.4rem;
  top: 1.2rem;
  bottom: 0;
  /* background: #fff; */
  overflow-y: scroll;
}
.cotainer .tips {
  padding: 0.54rem 0 0.26rem;
  color: #fff;
  font-size: 0.4rem;
}
.login-box{
  margin: .5rem auto;
  text-align: center;
}
.login-box .logo{
  width: 2.5rem;
  height: 2.5rem;
}
.login-box .title{
  padding: .2rem 0 0;
  color: #fff;
  font-size: .56rem;
}
.cotainer .input-box {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.32rem 0;
  border: 0.01rem solid #515151;
  border-radius: 6px;
}
.cotainer .input-pwd {
  margin-top: 0.76rem;
}
.cotainer .input-box .input {
  flex: 1;
  height: 100%;
  padding: 0 0.2rem;
  color: #fff;
  font-size: 0.42rem;
}
.cotainer .input-box .input::placeholder {
  color: #d7d7d7;
  font-size: 0.42rem;
}
.cotainer .input-box .code {
  color: #588bf8;
  font-size: 0.48rem;
}
.btn-login {
  width: 100%;
  margin-top: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/login.vue